import Display from "./components/Display";
// import ChatModal from "./components/chats/ChatModal";
import ChatModal2 from "./components/chats/ChatModal2";
import { useState, useEffect, useMemo } from "react";
import { embed, queryVectorStore } from "./components/brains/chat/localVector";
import {
  vectorStorer,
  vectorStorer2,
  querySimilarity,
  generateResponse,
  generateResponseHighlight
} from "./components/brains/chat/localMemVectors";
import { sum } from "./components/brains/chat/summarizer";
import Footer from './components/Footer'

function App() {
  const [text, getText] = useState("");

  // booleans
  const [highlightedText, getHighlightedText] = useState("");
  const [isHighlighted, getIsHighlighted] = useState(false);
  const [isChatLoading, setIsChatLoading] = useState(0); // 0 = no, 1 = loading, 2 = loaded
  const [isChatLoadingHighlights, setIsChatLoadingHighlights] = useState(0); // 0 = no, 1 = loading, 2 = loaded

  // basic chat
  const [userMessage, setUserMessage] = useState("");
  const [aiMessage, setAIMessage] = useState("");

  // highlight chat
  const [userMessageHighlights, setUserMessageHighlights] = useState("");
  const [aiMessageHighlights, setAiMessageHighlights] = useState("");
  const [allMessageHighlights, setAllMessageHighlights] = useState([]);


  // first message on pdf load
  const [firstPDFMessage, setFirstPDFMessage] = useState({});

  // all chats
  const [allChats, setAllChats] = useState([]);
  const [allChatsHighlights, setAllChatsHighlights] = useState([]);
  const [reset, setReset] = useState(0);
  const [PDF, setPDF] = useState(0);

  useMemo(() => {
    async function analyzeText() {
      setPDF(1);
      // empty out all chats
      setAllChats([]);
      setFirstPDFMessage({});

      setIsChatLoading(1);
      var query = `what are the three main points to best summarize this PDF. Provide a 1 or 2 sentence summary and then a list of 3 key questions that this pdf answers. Output this in an object like like: {"summary": "summary", "keyPoints": ["point1", "point2", "point3"]`;
      var vectorStore = await vectorStorer2(text);
      // console.log("vectorStore in App", vectorStore);
      var data = await querySimilarity(query);

      // var formattedSearchResults = await formatSearchResults(data);
      var resultFromBot = await generateResponse(query, data.join(". "));
      // console.log("resultFromBot", resultFromBot);
      // setAIMessage(resultFromBot);
      console.log(typeof resultFromBot);

    //   resultFromBot = resultFromBot.replace(/\\([\s\S])|(")/g, function(match, p1, p2) {
    //     if (p1) {
    //         return "\\" + p1;
    //     } else if (p2) {
    //         return '\\"';
    //     }
    // });


    // resultFromBot = JSON.parse(resultFromBot);
      console.log("resultFromBot", resultFromBot)
    

      try {
        
        setFirstPDFMessage(JSON.parse(resultFromBot));
        console.log("we did goo!!")

      } catch {
        console.log("incorrect format from bot!");
        // const firstIndex = resultFromBot.indexOf("{");
        // const secondIndex = resultFromBot.indexOf("{", firstIndex + 1);

        let startIndex = resultFromBot.indexOf("{");
        let endIndex = resultFromBot.lastIndexOf("}");
        let dataString = resultFromBot.substring(startIndex, endIndex + 1);
        let dataObject = JSON.parse(dataString);
        setFirstPDFMessage({
          // summary: resultFromBot.substring(1, secondIndex),
          // keyPoints: resultFromBot.substring(secondIndex)
          summary: dataObject['summary'],
          keyPoints: dataObject['keyPoints']
        });
      }
      setIsChatLoading(2);
    }
    if (text.length > 100) {
      // console.log("i am isChatLoading ANALYZING", isChatLoading);

      analyzeText();
    }
  }, [text]);


  // FROM HIGHLIGHTS
  // console.log("i am isChatLoading", isChatLoading, text);
  useEffect(() => {
    async function analyzeText() {
      // console.log("userMessageHighlights in App", userMessageHighlights);
      setIsChatLoadingHighlights(1);
      var resultFromBot = await generateResponseHighlight(
        userMessageHighlights, reset
      );
      setAiMessageHighlights(resultFromBot);
      // console.log("HIH JLIGHTS", resultFromBot);
      setIsChatLoadingHighlights(2);

      setAllMessageHighlights((prevAllMes) => [...prevAllMes, resultFromBot])
      console.log("aiMessageHighlights", aiMessageHighlights, resultFromBot)
      // var resultFromBot = await generateResponse(query, data.join(". "));

    }
    if (userMessageHighlights.length > 5) {
      analyzeText();
    }
  }, [userMessageHighlights]);

  // for normal chat
  useEffect(() => {
    async function analyzeText() {


      setIsChatLoading(1);

      var query = userMessage;
      // var vectorStore = await vectorStorer2(text);
      // console.log("vectorStore in App", vectorStore);
      var data = await querySimilarity(query);

      console.log("i am the data!", data)

      // var formattedSearchResults = await formatSearchResults(data);
      var resultFromBot = await generateResponse(query, data.join(". "));
      setAIMessage(resultFromBot);
      // console.log("resultFromBot", resultFromBot);
      setIsChatLoading(2);
    }
    if (userMessage.length > 1) {
      analyzeText();
    }
  }, [userMessage]);

  useMemo(() => {
    // console.log("i am the RESET!", reset)
    // if(reset)
    // {
    // console.log("i am the RESET! inside", reset)

    // setUserMessage('')
    // setAIMessage('')
    //   setAllChats([])
    //   setReset(0)
    // }
  }, [reset])

  useEffect(() => {
    setAllChats((prevChats) => [...prevChats, aiMessage]);
  }, [aiMessage]);
  useEffect(() => {
    setAllChats((prevChats) => [...prevChats, userMessage]);
  }, [userMessage]);

  useEffect(() => {
    setAllChatsHighlights((prevChats) => [...prevChats, aiMessageHighlights]);
  }, [aiMessageHighlights]);
  useEffect(() => {
    setAllChatsHighlights((prevChats) => [...prevChats, userMessageHighlights]);
  }, [userMessageHighlights]);

  // console.log("i am allMessageHighlights APP", setAllChatsHighlights);
  // creating new plugin instance
  return (
    <div className="container">
      {/* Upload PDF */}
      <Display
        getHighlightedText={getHighlightedText}
        getIsHighlightedText={getIsHighlighted}
        getText={getText}
        isChatLoading={isChatLoading}
        getUserMessage={setUserMessage}
        chats={allChats}
        firstPDFMessage={firstPDFMessage}
        setReset={setReset}
        reset={reset}
        PDF={PDF}
      />
      {isHighlighted && PDF && (
        <ChatModal2
          allMessageHighlights={allMessageHighlights}
          getIsHighlightedText={getIsHighlighted}
          isChatLoading={isChatLoadingHighlights}
          setUserMessageHighlights={setUserMessageHighlights}
          allChatsHighlights={allChatsHighlights}
        />
      )}
      <br />
      <Footer />
    </div>
  );
}

export default App;
